/**
 * The journey record, available to any screen that needs more than the
 * reservation — chiefly step 3, which has to name the actual documents the back
 * office sent rather than a generic "rental contract".
 *
 * Null outside a provider, and null for a visit with no ?id=. Callers fall back
 * to their own copy so a screen rendered on its own still draws.
 */

import React, { createContext, useContext, ReactNode } from "react";
import { Onboarding } from "./onboardingConfig";

const OnboardingContext = createContext<Onboarding | null>(null);

export const OnboardingProvider = ({
  onboarding,
  children,
}: {
  onboarding: Onboarding | null;
  children: ReactNode;
}) => (
  <OnboardingContext.Provider value={onboarding}>
    {children}
  </OnboardingContext.Provider>
);

export const useOnboardingRecord = (): Onboarding | null =>
  useContext(OnboardingContext);
